import { supabase } from '@/integrations/supabase/client';

/* A LEI DAS LINHAS, em um lugar só: primária → secundária → reserva da equipe.
   Estava escrita dentro do useAbrirConversaInbox; a gaveta do Kanban precisa da
   MESMA cadeia para criar conversa, e duas cópias da lei divergem no primeiro
   ajuste que só um dos lados receber. */
export async function resolverConexaoDoUsuario(userId: string): Promise<string | null> {
  const { data: usr } = await supabase
    .from('usuarios')
    .select('whatsapp_connection_id, whatsapp_connection_id_secundaria, equipe_id')
    .eq('id', userId)
    .maybeSingle();

  const candidatos: string[] = [];
  if (usr?.whatsapp_connection_id) candidatos.push(usr.whatsapp_connection_id);
  if (usr?.whatsapp_connection_id_secundaria) candidatos.push(usr.whatsapp_connection_id_secundaria);
  if (usr?.equipe_id) {
    const { data: eq } = await supabase
      .from('equipes')
      .select('whatsapp_connection_id_reserva')
      .eq('id', usr.equipe_id)
      .maybeSingle();
    if (eq?.whatsapp_connection_id_reserva) candidatos.push(eq.whatsapp_connection_id_reserva);
  }
  if (candidatos.length === 0) return null;

  /* Conversa NOVA nasce na conexão que está NO AR (pula a caída). Conversa
     ANTIGA na conexão caída NÃO é afetada — ela espera a linha voltar. */
  const { data: saude } = await supabase
    .from('whatsapp_connection_health')
    .select('connection_id, health_status')
    .in('connection_id', candidatos);
  const caidas = new Set(
    (saude || [])
      .filter((h) => (h as { health_status?: string }).health_status === 'critical')
      .map((h) => (h as { connection_id?: string }).connection_id),
  );
  return candidatos.find((id) => !caidas.has(id)) ?? candidatos[0];
}
